export default __webpack_public_path__ + "static/media/Montserrat-Bold.58bd585c.woff";